import DisplayData from 'portaltransparencia-common/components/displaydata/DisplayData.react.js';
import DisplayDataItem from 'portaltransparencia-common/components/displaydata/DisplayDataItem.react.js';
import DisplayDataRow from 'portaltransparencia-common/components/displaydata/DisplayDataRow.react.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import NumberUtils from 'portaltransparencia-common/libs/NumberUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import { Col } from 'react-bootstrap';
import Component from 'react-pure-render/component';

export class AutonomoDetalheInformacao extends Component {
  static propTypes = {
    autonomo: PropTypes.object.isRequired,
    dadosPensao: PropTypes.object,
    usaWebService: PropTypes.bool.isRequired,
    anotacoes: PropTypes.object.isRequired,
    exibeSalarioBase: PropTypes.bool.isRequired,
    horarioFlexivel: PropTypes.object.isRequired,
    uf: PropTypes.string
  };

  renderDadosPensao = () => {
    const { dadosPensao } = this.props;

    if (dadosPensao && dadosPensao.has('tipoBeneficio')) {
      return (
        <div>
          <DisplayDataRow>
            <DisplayDataItem
              sm={4}
              title="Tipo de Benefício"
              value={dadosPensao.get('tipoBeneficio')}
              id="tipoBeneficio"
            />
            <DisplayDataItem
              sm={5}
              title="Parentesco"
              value={dadosPensao.get('parentesco')}
              id="parentesco"
            />
            <DisplayDataItem
              sm={3}
              title="Parcela Percentual da Pensão"
              value={dadosPensao.get('percentualBeneficio')}
              id="percentualPensao"
            />
          </DisplayDataRow>

          <DisplayDataRow>
            <DisplayDataItem
              sm={6}
              title="Origem da Pensão"
              value={dadosPensao.get('origemPensao')}
              id="origemPensao"
            />
            <DisplayDataItem
              sm={6}
              title="Data de Óbito"
              value={DateUtils.formatDateTimeShort(
                dadosPensao.get('dataObito')
              )}
              id="dataObito"
            />
          </DisplayDataRow>

          <DisplayDataRow>
            <DisplayDataItem
              sm={6}
              title="Cargo da Origem da Pensão"
              value={dadosPensao.get('cargoOrigemPensao')}
              id="cargoOrigemPensao"
            />
            <DisplayDataItem
              sm={6}
              title="Entidade Origem"
              value={dadosPensao.get('entidadeOrigem')}
              id="entidadeOrigem"
            />
          </DisplayDataRow>
        </div>
      );
    }

    return null;
  };

  renderAnotacoes() {
    const { anotacoes } = this.props;

    if (anotacoes && !anotacoes.isEmpty()) {
      return (
        <DisplayDataRow>
          <div>
            <b className="dd-title">Anotações</b>
            <div className="col-sm-12 col-md-12">
              <div className="dd-content">
                <ul id="anotacoes">
                  {anotacoes.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </DisplayDataRow>
      );
    }

    return null;
  }

  renderDadosCargo() {
    const { autonomo, usaWebService, exibeSalarioBase } = this.props;

    if (!exibeSalarioBase || usaWebService) {
      return (
        <DisplayDataRow>
          <DisplayDataItem
            sm={8}
            title="Cargo"
            value={autonomo.get('descricaoCargo')}
            id="descricaoCargo"
            show={autonomo.has('descricaoCargo')}
          />
          <DisplayDataItem
            sm={4}
            title="Faixa"
            value={autonomo.get('faixa')}
            id="faixa"
            show={autonomo.has('faixa')}
          />
        </DisplayDataRow>
      );
    } else {
      return (
        <DisplayDataRow>
          <DisplayDataItem
            sm={5}
            title="Cargo"
            value={autonomo.get('descricaoCargo')}
            id="descricaoCargo"
            show={autonomo.has('descricaoCargo')}
          />
          <DisplayDataItem
            sm={3}
            title="Faixa"
            value={autonomo.get('faixa')}
            id="faixa"
            show={autonomo.has('faixa')}
          />
          <DisplayDataItem
            sm={4}
            title="Valor"
            value={NumberUtils.format(autonomo.get('salarioBase'))}
            id="salarioBase"
            show={autonomo.has('faixa') && autonomo.has('salarioBase')}
          />
        </DisplayDataRow>
      );
    }
  }

  renderPeriodo = (inicio, fim) =>
    DateUtils.formatTime(inicio) + ' às ' + DateUtils.formatTime(fim);

  renderHorario = item => (
    <span>
      <b>{item.get('dia') + ': '}</b>
      {item.get('entrada1') &&
        this.renderPeriodo(item.get('entrada1'), item.get('saida1'))}
      {item.get('entrada2') &&
        ' ' + this.renderPeriodo(item.get('entrada2'), item.get('saida2'))}
      {item.get('entrada3') &&
        ' ' + this.renderPeriodo(item.get('entrada3'), item.get('saida3'))}
      {item.get('entrada4') &&
        ' ' + this.renderPeriodo(item.get('entrada4'), item.get('saida4'))}{' '}
    </span>
  );

  renderHorarioFlexivel() {
    const { horarioFlexivel } = this.props;

    return (
      <Col sm={8}>
        <b className="dd-title">Horário de Trabalho</b>
        <div className="dd-content" id={'horarioTrabalhoFlexivel'}>
          {horarioFlexivel.map(this.renderHorario)}
        </div>
      </Col>
    );
  }

  render() {
    const { autonomo, usaWebService, uf, exibeSalarioBase } = this.props;

    if (!autonomo) {
      return null;
    }

    return (
      <section>
        <DisplayData border>
          <DisplayDataRow>
            <DisplayDataItem
              sm={5}
              title="Nome"
              value={autonomo.get('nome')}
              id="nome"
            />

            <DisplayDataItem
              sm={3}
              title="Matrícula"
              value={autonomo.get('matricula')}
              id="matricula"
            />

            <DisplayDataItem
              sm={4}
              title="Situação"
              value={autonomo.get('situacao')}
              id="situacao"
            />
          </DisplayDataRow>

          <DisplayDataRow>
            <DisplayDataItem
              sm={4}
              title="Lotação"
              value={autonomo.get('descricaoLotacao')}
              id="descricaoLotacao"
            />

            <DisplayDataItem
              sm={4}
              title="Classe / Natureza"
              value={autonomo.get('descricaoClasse')}
              id="descricaoClasse"
              show={!usaWebService && autonomo.has('descricaoClasse')}
            />

            <DisplayDataItem
              sm={4}
              title="C.B.O."
              value={autonomo.get('cbo')}
              id="cbo"
              show={!usaWebService && autonomo.has('cbo')}
            />
          </DisplayDataRow>

          <DisplayDataRow>
            <DisplayDataItem
              sm={4}
              title="Data do Contrato"
              value={DateUtils.formatDateTimeShort(
                autonomo.get('dataAdmissao')
              )}
              id="dataAdmissao"
              show={
                (uf != 'RO' ||
                  (autonomo.get('definicaoClasse') != 8 &&
                    autonomo.get('definicaoClasse') != 9)) &&
                autonomo.has('dataAdmissao')
              }
            />

            <DisplayDataItem
              sm={4}
              title="Tipo de Remuneração"
              value={autonomo.get('tipoRemuneracao')}
              id="tipoRemuneracao"
              show={!usaWebService && autonomo.has('tipoRemuneracao')}
            />

            {exibeSalarioBase && (
              <DisplayDataItem
                sm={4}
                title="Valor Global do Contrato"
                value={NumberUtils.format(autonomo.get('salarioBase'))}
                id="salarioBase"
                show={autonomo.has('salarioBase')}
              />
            )}
          </DisplayDataRow>
          <DisplayDataRow>
            <DisplayDataItem
              sm={4}
              title="Descrição das Atividades"
              value={autonomo.get('descricaoAtividades')}
              id="descricaoAtividades"
              show={!usaWebService && autonomo.has('descricaoAtividades')}
            />
          </DisplayDataRow>
        </DisplayData>
      </section>
    );
  }
}

export default AutonomoDetalheInformacao;
